module.exports = __webpack_public_path__ + "static/media/cybercrime.677941b6.png";